import { css } from '@emotion/core';

const labelLineHeight = css`
    line-height: 1.4166rem;
`;

export default labelLineHeight;
